import axios from "axios";

export function getTagList(co) {
    const config = {
      params: co,
    };
    return axios.get(
      process.env.VUE_APP_API_URL + "Tag/getlist",
      config
    );
  }
 
  // export function postTag(data) {

  //   console.log("şu an serviste")

  //   console.log(data)
  //   const config = {
  //     headers: { "Content-Type": "multipart/form-data" },
  //   };
  //   return axios.post(
  //     process.env.VUE_APP_API_URL + "Tag/insert",
  //     data,
  //     config
  //   );
  // }

  export function postTag(data) {
    return axios.post(process.env.VUE_APP_API_URL + "Tag/insert", data);
  }
